import { createAction, props } from '@ngrx/store';

export const clearText = createAction(
  '[Input Component] ClearText',
  props<{ doClear: boolean }>()
);
